import React, { Component, useRef, useMemo, useState, useEffect } from "react";
import { useTable, useExpanded } from "react-table";
import { getToken } from "../../utils/common";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import moment from "moment";
import NoteModal from "./NoteModal"
import { useHistory } from "react-router-dom";
import ReactTableComponent from "../Table/ReactTablecomponent";
import LeadDetails from "./LeadDetails";
import Filter from "../Filter/filter"
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { log } from "@craco/craco/lib/logger";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tabPanel: {
    width: '80%'
  },
  textField: {
    width: '90%'
  },
  tab: {

  },
  ul: {
    "& .MuiPaginationItem-root": {
      backgroundColor: "#500E4B",
      color: '#fff'
    }
  }
}));

export default function Leads({ }) {
  const [paginationstatus, setPaginationStatus] = useState(false);
  const [dataTable, setDataTable] = useState([]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  //const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0)
  const [catogories, setCatogories] = useState([])
  const [catogorieySelected, setCatogorieySelected] = useState(null)
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [notesOpen, setnotesOpen] = useState(false);
  const [isInternational, setIsInternational] = useState(false);
  const [mystaffID, setMyStaffID] = useState()
  const [staffList, setStaffList] = useState([])
  const [searchValue, setSearchValue] = useState()
  const [itineryid, setItineryID] = useState()
  const [rooms, setRooms] = useState([])
  const [deckNo, setDeckNo] = useState(null)
  const [bedNo, setBedNo] = useState(null)
  const [status, setStatus] = useState(null)
  const [roomNo, setRoomNo] = useState(null)
  const [page, setPage] = useState(1)
  const [uploadOpen, setUploadOpen] = useState(false);
  const [booking_id, setBooking_id] = useState("")
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [showUploadGuestFile, setShowUploadGuestFile] = useState(true);
  let history = useHistory();

  let editableStatus = JSON.parse(localStorage.getItem("UserProfile"));
  console.log(editableStatus)


  useEffect(() => {
    var param = ""
    enquiryListApi(param, 1)
  }, [paginationstatus]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const enquiryListApi = (param, count) => {
    console.log(count)
    // if(search == undefined) {
    //     var searchValue = '';
    // } else {
    //     var searchValue = search;
    // }
    // if(count == "all") {
    //     var url = 'enquiries?';
    // } else {
    //     var url = 'enquiries?staff_id='+count
    // }
    fetch(process.env.REACT_APP_API_ENDPOINT + '/group_portal/booking_rooms?page=' + count + param, {
      method: 'GET',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization:
          `Bearer ${getToken()}`,
      },
    }).then((response) => {
      if (response.ok) {
        return response.json()
      }
      throw Error("Verification failed");
    }
    ).then((response) => {
      var dummySetdata = [];
      console.log(response);
      var responseData = response.booking_rooms;
      setShowUploadGuestFile(response.show_upload_guest_file)
      responseData.map((data) => {
        var roomContainer = [{
          "adults": parseInt(data.guest_details.adults_count),
          "children": parseInt(data.guest_details.children_count),
          "infants": parseInt(data.guest_details.infants_count),
        }]
        setBooking_id(data.booking_id)
        dummySetdata.push(
          {
            "id": data.id,
            "room_number": data.ship_room.number,
            "catogory": data.category.name,
            "guests_count": data.guests_count,
            "beds": data.ship_room.beds,
            "status": data.guests.length > 0 ? "Submitted" : "Not Submitted",
            "rooms": roomContainer,
            "booking_id": data.id,
            "guest": data.guests,
            "bedSelection": data.bed_selection,
          }
        )
      })
      setTotalPages(response.pagination.total_pages);
      setDataTable(dummySetdata);
      setCatogories(response.categories)
      setLoading(false);
      setIsInternational(response.is_international);
      // document.getElementsByClassName('scroll-to-top')[0].scrollTop = 0;
    }).catch((err) => console.log(err));
  }

  const columns = React.useMemo(
    () => [
      {
        Header: () => null,
        id: 'expander',
        Cell: ({ row }) => (
          <span {...row.getToggleRowExpandedProps()}>
            {row.isExpanded ? <i className="fas fa-chevron-circle-up text-j-magenta"></i> : <i className="fas fa-chevron-circle-down text-j-magenta"></i>}
          </span>
        ),
      },
      {
        Header: 'Room',
        accessor: 'room_number',
        maxWidth: 150,
        Cell: (props) => {
          return <p style={{ width: '120px' }}>{props.value}</p>
        }
      },
      {
        Header: 'Catogory',
        accessor: 'catogory',
        Cell: (props) => {
          return <p style={{ width: '150px', wordBreak: 'break-word' }}>{props.value}</p>
        }
      },
      {
        Header: 'Guest Count',
        accessor: 'guests_count',
      },
      {
        Header: 'Number of Beds',
        accessor: 'beds',
        width: 60,
        Cell: (props) => {
          return (<>
            <div className="flex justify-center">{props.value}</div>
          </>)
        },
      },
      {
        Header: 'Status',
        accessor: 'status',
        width: 60,
        Cell: (props) => {
          return (<>
            <div className="flex justify-center">{props.value}</div>
          </>)
        },
      }
    ],
    []
  )

  const handleOpenNotes = (id) => {
    setItineryID(id)
    setnotesOpen(true)
  }

  const handleNotesClose = () => {
    setnotesOpen(false)
  }

  const handleDetails = (id) => {
    // history.push('/admin/lead-details')
    history.push({
      pathname: '/admin/lead-details',
      state: { id: id }
    })
  }



  const RenderRowSubComponent = ({ i }) => {
    const joiObject = {};


    return (
      <>
        <LeadDetails dataTable={dataTable} i={i} editableStatus={editableStatus.edit_guest} isInternational={isInternational} />
      </>
    )
  }

  const onChangeStaff = (e) => {
    console.log(e.target.value)
    setMyStaffID(e.target.value)
    enquiryListApi(e.target.value, '');
  }

  const onChangeSearch = (e) => {
    setSearchValue(e.target.value)
  }

  const handleSearch = () => {
    enquiryListApi(mystaffID, searchValue);
  }

  const handleFilterDecksFun = () => {
    var param = "&deck=" + deckNo;
    enquiryListApi(param, page)
  }

  const handleFilterRoomsFun = () => {
    var param = "&room_no_search=" + roomNo;
    enquiryListApi(param, page)
  }

  const handleFilterStatusFun = () => {
    var param = "&guest_filled=" + status;
    enquiryListApi(param, page)
  }

  const handleFilterCatogoryFun = () => {
    var param = "&category_id=" + catogorieySelected;
    enquiryListApi(param, page)
  }

  const handleFilterDecks = (e) => {
    setDeckNo(e.target.value)
  }

  const handleFilterRooms = (e) => {
    setRoomNo(e.target.value)
  }

  const handleFilterStatus = (e) => {
    setStatus(e.target.value)
  }

  const handleFilterCatogory = (e) => {
    setCatogorieySelected(e.target.value)
  }

  const clearFilter = () => {
    var param = ""
    setBedNo("")
    setStatus("")
    setDeckNo("")
    setRoomNo("")
    setCatogorieySelected("")
    enquiryListApi(param, 1)
  }

  const handlePageChange = (event, value) => {
    console.log(value)
    var param;
    if (deckNo != null) {
      param = "&deck=" + deckNo;
    } else {
      param = ""
    }
    if (bedNo != null) {
      param = "&beds=" + bedNo;
    } else {
      param = ""
    }
    if (status != null) {
      param = "&guest_filled=" + status
    }
    else {
      param = ""
    }
    // if(catogories != null) {
    //   param = "&category_id"+catogories
    // }else {
    //   param = ""
    // }
    setPage(value);
    enquiryListApi(param, value);
  };

  const handleUpload = () => {
    setUploadOpen(true);
  }
  const handleModalClose = () => {
    setUploadOpen(false);
  };
  const handleDownloadSample = () => {
    const fileUrl = 'https://cordelia-images-prod.s3.ap-south-1.amazonaws.com/cordelia_prod/Sample+Guest+Detail.csv';
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'Group_booking_sample.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };
  const handleSubmit = async () => {
    if (selectedFile) {
      try {
        setUploadLoading(true)
        let formDataFile = new FormData();
        formDataFile.append('file', selectedFile);
        const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/group_portal/bookings/${booking_id}/upload_guests`, {
          method: 'PATCH',
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          body: formDataFile,
        });
        const data = await response.json();
        if (response.ok) {
          setUploadLoading(false)
          console.log('File uploaded successfully');
          var param = ""
          enquiryListApi(param, 1)
          setUploadOpen(false)
        } else {
          setUploadLoading(false)
          if (data?.errors && Array.isArray(data.errors)) {
            const errorMessages = data.errors.map((err, index) => `• ${err}`).join('\n');
            alert(`File upload failed with errors:\n${errorMessages}`);
          } else {
            alert('File upload failed: Unknown error.');
          }
        }
      } catch (error) {
        setUploadLoading(false)
        console.error('Error uploading file:', error);
        alert('Error uploading file');
      }
    } else {
      alert('Please select a file to upload');
      console.log('No file selected');
    }
  };

  let data = dataTable;
  const tableInstance = useTable({ columns, data }, useExpanded)
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    visibleColumns,
    state: { expanded },
  } = tableInstance

  return (
    <>
      <div className="grid grid-cols-1 mr-4 pl-4 pb-4">
        <div className="grid grid-cols-2">
          <h1 className="text-xl font-bold p-4">Filter</h1>
          <div className="flex justify-end">
            {showUploadGuestFile && <button className="bg-opacity-500 mb-2 rounded text-sm font-semibold hover:bg-opacity-75 text-gray-600 border ml-3 w-4/12 mr-4 hover:bg-gray-300" onClick={handleUpload}>
              Upload guest file
            </button>}
            <button className="bg-opacity-500 mb-2 rounded text-sm font-semibold hover:bg-opacity-75 text-gray-600 border ml-3 w-4/12 mr-4 hover:bg-gray-300" onClick={() => clearFilter()}>Clear All</button>
          </div>
        </div>

        <Filter
          handleFilterDecks={handleFilterDecks}
          handleFilterRooms={handleFilterRooms}
          handleFilterStatus={handleFilterStatus}
          handleFilterDecksFun={handleFilterDecksFun}
          handleFilterRoomsFun={handleFilterRoomsFun}
          handleFilterStatusFun={handleFilterStatusFun}
          catagoriesFilter={catogories}
          handleFilterCatogory={handleFilterCatogory}
          handleFilterCatogoryFun={handleFilterCatogoryFun}
          deckNoData={deckNo}
          statusData={status}
          roomNoData={roomNo}
          catogorieySelectedData={catogorieySelected}
        />
      </div>
      <div className="ml-8 mr-8">
        <div className="overflow-x-auto">
          <div className="min-w-screen bg-gray-100 flex items-center justify-center bg-gray-100 font-sans overflow-hidden">
            <ReactTableComponent
              columns={columns}
              data={data}
              loading={loading}
              renderRowSubComponent={RenderRowSubComponent}
              count={totalPages}
              page={page}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
      <Modal
        open={uploadOpen}
        onClose={handleModalClose}
        aria-labelledby="upload-guest-file"
        aria-describedby="upload-guest-file-modal"
      >
        <div className="fixed inset-0 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 md:mx-0 border-t-4 border-blue-500 shadow-lg">
            <Typography
              variant="h6"
              className="text-xl font-bold pb-4 text-center"
            >
              UPLOAD FILE
            </Typography>
            <div className="flex flex-col space-y-4 mb-4">
              <div className="flex space-x-4">
                <Button
                  variant="contained"
                  onClick={handleDownloadSample}
                  className="flex-1 px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white"
                  style={{ minHeight: '48px', fontSize: '12px' }}
                >
                  Download Sample File
                </Button>
                <input
                  accept=".csv, .xls, .xlsx"
                  style={{ display: 'none' }}
                  id="raised-button-file"
                  type="file"
                  onChange={handleFileUpload}
                />
                <label htmlFor="raised-button-file" className="flex-1">
                  <Button
                    variant="contained"
                    component="span"
                    className="w-full px-3 py-2 bg-green-500 hover:bg-green-600 text-white"
                    style={{ minHeight: '48px', fontSize: '12px' }}
                  >
                    Select Guest File
                  </Button>
                </label>
              </div>
              {selectedFile ? (
                <div>{selectedFile?.name}</div>
              ) : null}
              <div className="flex justify-end space-x-4 mt-4">
                <Button
                  disabled={uploadLoading}
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  className="flex-1 md:flex-none px-3 py-2 bg-blue-500 hover:bg-blue-600 text-white"
                  style={{ minHeight: '48px' }}
                >
                  Upload
                </Button>
                <Button
                  variant="outlined"
                  color="default"
                  onClick={handleModalClose}
                  className="flex-1 md:flex-none px-3 py-2 border border-gray-300 text-gray-700 hover:bg-gray-100 "
                  style={{ minHeight: '48px' }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Modal>



    </>
  )
}


